<template>
    <div id="page">
         <div class="page-content header-clear-medium">
            <div data-height="cover" class="caption bottom-0">
                <div class="topmargin">
                    <div class="landing-page">
                        <div class="landing-header">
                            <a href="#"><img class="logo-icon" src="@/assets/images/logo.png" alt="img"></a>
                            <h2 class="center-text top-20">Hi {{ user.name }}</h2>
                        </div>
                        <div class="landing-icons color-theme">
                            <router-link :to="{ name: 'Dashboards' }">
                                <i class="bg-yellow2-light shadow-icon-large fas fa-chart-pie"></i>
                                <em class="color-theme">Dashboards</em>
                            </router-link>
                            <router-link :to="{ name: 'Accounting' }">
                                <i class="bg-blue2-dark shadow-icon-large fas fa-calculator"></i>
                                <em class="color-theme">Accounting</em>
                            </router-link>
                            <a href="https://login.microsoftonline.com/?whr=skycallas.no">
                                <i class="bg-red2-light shadow-icon-large fab fa-microsoft"></i>
                                <em class="color-theme">Office 365</em>
                            </a>
                            <a href="msteams:/l/chat/0/0">
                                <i class="bg-magenta2-light shadow-icon-large fas fa-comments"></i>
                                <em class="color-theme">Chat</em>
                            </a>
                            <router-link :to="{ name: 'Settings' }">
                                <i class="bg-dark2-light shadow-icon-large fa fa-cog"></i>
                                <em class="color-theme">Settings</em>
                            </router-link>
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>


export default {
  name: 'Home',
  components: {
  },
  data() {
      return{
          isAdmin: false
      }
  },
  created(){
    this.user = JSON.parse(localStorage.getItem('user'));
    
    // if (this.user == null){
    //     if(!localStorage.getItem('loginLoad')){
    //         setTimeout(()=> {
    //             localStorage['loginLoad'] = true
    //             location.reload()
    //         },500)
    //     } else {
    //         this.$router.push({ name: 'Login' })
    //     }
            
    // }
    // firebase.auth().currentUser.getIdTokenResult().then(idTokenResult => {
    //     this.isAdmin = idTokenResult.claims.admin
    // })
  }
}
</script>

<style>

.cap-center{
    vertical-align: middle;
    padding: 20px;
    max-width: 500px;
    margin-top: 50px;
}

.landing-page .logo-icon{
    padding-bottom:15px;
}

</style>